import axios from "../api/api"
import { useEffect, useState } from "react";
import { Modal, Table } from "react-bootstrap";

const GETDATABYID = "/api/vidhyaman"

const VidhyamanModal = ({ show, setShow, id, setId }) => {
    const [content, Setcontent] = useState([])

    useEffect(() => {
        const getdatabyid = async () => {
            if(show === true) {
                const response = await axios.get(`${GETDATABYID}/${id}`)
                const data = response.data
              Setcontent(data)

            } else {
             
                Setcontent([])
            }
        }
        getdatabyid()
    }, [id])

    // Handle hide
    const handleHide = () => {
        setId(null);
        setShow(false);
    }



    return (
        <Modal show={show} onHide={handleHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title> जैन धर्म तीर्थंकर -{content?.vidhyamanchaubisi?.hindititle} </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Table bordered striped hover>
                    <tbody>
                        <td>{content?.vidhyamanchaubisi?.content}</td>
                    </tbody>
                </Table>
            </Modal.Body>
        </Modal>
    )
}

export default VidhyamanModal;